import React, { useState } from "react";
import { TextField, InputAdornment, makeStyles } from "@material-ui/core";
import config, { mobileNumberLimit } from "../../../config";
import RadioGroup from "@material-ui/core/RadioGroup";
import { useDispatch, useSelector } from "react-redux";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
//import { useDispatch } from "react-redux";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useBilling } from "../KOTbillingProvider";
import Redeemmodal from "./Modals/redeemModal";
import Button from "@mui/material/Button";
import ConfirmModal from "./Modals/confirmModal";
import { CloseOutlined } from "@mui/icons-material";
import AddItemModal from "./Modals/createKot";
import { useCurrency } from "../../../provider/courtryProvider";

const useStyles = makeStyles((theme) => ({
  dashStyle: {
    borderTop: "2px dashed #000",
    overflow: "hidden",
    position: "relative",
    textAlign: "center",
    padding: "10px",
    "& :before": {
      content: "",
      position: "absolute",
      borderTop: "5px dashed #000",
      top: -3,
      bottom: -3,
      left: -3,
      right: -3,
    },
  },
}));

const BillingPayDetails = () => {
  const classes = useStyles();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const shopDetails = useSelector((state) => state.shopDetails);
  const { getSubTotal, getTotalAmount } = useBilling();
  const billLineSettings = useSelector((state) => state.settings.settings);
  const [isRedeemModal, setIsRedeemModal] = useState(false);
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [addItemModal, setAddItemModal] = useState(false);
  const dispatch = useDispatch();
  // const { getTotalAfterLoyalty } = useBilling();
  const billTotalAfterLoyalty = 0;
  //const dispatch = useDispatch();
  const billingPayload = useSelector((state) => state.billingPayload.data);
  const currencyFormatter = useCurrency();

  const handleLoyalityPoints = () => {
    dispatch({
      type: "SET_LOYALTY_POINTS",
      payload: {},
    });
  };

  const handlePrintKot = () => {
    if (billingPayload.items?.length <= 0) {
      return alert("Please add product(s) to Create KOT.");
    }
    setAddItemModal(true);
  };

  const handleGenerateBill = () => {
    const reg = new RegExp("^[0-9]*$");
    if (billingPayload.items?.length <= 0) {
      return alert("Please add product(s) to generate bill.");
    }
    if (reg.test(billingPayload.customerPhoneNumber.length) === false) {
      return alert("Please enter valid phone number");
    }
    if (
      billingPayload.customerPhoneNumber.length < 10 &&
      billingPayload.customerPhoneNumber.length >= 1
    ) {
      return alert("Please enter valid phone number");
    }
    if (
      billingPayload.customerPhoneNumber.length === 10 &&
      billingPayload.customerName === ""
    ) {
      return alert("Please enter customer name");
    }
    if (billLineSettings.discount) {
      if (
        (billingPayload.discount !== "" ||
          parseInt(billingPayload.discount) !== 0) &&
        billingPayload.discountType === ""
      )
        return alert("Please select discount type.");
    }

    setIsConfirmModal(true);
    //setBillLoading(true);
  };

  const handlePaymentChange = (e) => {
    dispatch({
      type: "UPDATE_PAYMENT_METHOD",
      payload: e.target.value,
    });
  };

  const handleCouponClick = () => {
    dispatch({
      type: "SET_COUPON",
      payload: {},
    });
  };

  const handleCustomerNameChange = (e) => {
    const value = e.target.value;
    dispatch({
      type: "SET_BILLING_PAYLOAD",
      payload: {
        ...billingPayload,
        customerName: value,
      },
    });
  };

  const getCustomerDetail = async (customerPhoneNo) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/customer/getCustomerDetailswithLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          phoneNumber: customerPhoneNo ? `+91${customerPhoneNo}` : undefined,
          shopId: shopId,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        dispatch({
          type: "SET_BILLING_PAYLOAD",
          payload: {
            ...billingPayload,
            customerName: data.customerName !== null ? data.customerName : "",
            customerPhoneNumber: customerPhoneNo,
            loyaltyPoints: data.loyaltyPoints,
          },
        });
      })
      .catch((err) => {
        console.error("getCustomerDetail", err);
      });
  };

  const handleCustomerNumberChange = (e) => {
    const value = e.target.value;

    dispatch({
      type: "SET_BILLING_PAYLOAD",
      payload: {
        ...billingPayload,
        customerPhoneNumber: value,
      },
    });
    if (value.length !== mobileNumberLimit) {
      return;
    }
    const regExp = /^[0]?[56789]\d{9}$/;
    if (regExp.test(value) === false) {
      setTimeout(() => {
        alert("Enter valid phone number");
      }, 100);
      return;
    }
    getCustomerDetail(value);
  };

  return (
    <div
      className="rightContainer"
      style={{
        margin: "0",
        height: "100%",
        flexDirection: "column",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div>
        <div className="customerDetails">
          <div className="customerDetails-name">
            <p>Customer Details</p>
          </div>
          <div style={{ display: "flex" }}>
            <div className="customerDetails-number" style={{ marginRight: 5 }}>
              <TextField
                size="small"
                placeholder="Number"
                variant="outlined"
                value={billingPayload.customerPhoneNumber}
                onChange={handleCustomerNumberChange}
                inputProps={{ maxLength: mobileNumberLimit }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {shopDetails.country.dialCode}
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="customerDetails-name">
              <TextField
                size="small"
                placeholder="Name"
                variant="outlined"
                value={billingPayload.customerName}
                onChange={handleCustomerNameChange}
              />
            </div>
          </div>
          {Math.ceil(
            (new Date(shopDetails.loyaltyExpiryDate) - new Date()) /
              (1000 * 60 * 60 * 24)
          ) > 0 &&
            shopDetails.loyaltyRatio && (
              <div className="customerDetails-loyaltypts">
                <div className="customerDetails-loyaltypts-name">
                  <p style={{ marginRight: 5 }}>Avail Loyalty Pts:</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "fit-content",
                      borderBottom: "0.2px dashed #000000",
                    }}
                  >
                    <p>{billingPayload.loyaltyPoints}</p>
                  </div>
                </div>
                <div
                  className="customerDetails-loyaltypts-redeem"
                  onClick={() => setIsRedeemModal((prev) => !prev)}
                >
                  <p>Reedem</p>
                </div>
              </div>
            )}
        </div>

        <FormControl onClick={handlePaymentChange}>
          <FormLabel id="demo-row-radio-buttons-group-label">
            Payment Method
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={billingPayload.paymentMethod}
          >
            <FormControlLabel
              value="cash"
              control={<Radio />}
              label="Cash Amount"
            />
            <FormControlLabel value="upi" control={<Radio />} label="UPI Pay" />
            <FormControlLabel
              value="card"
              control={<Radio />}
              label="Debit/Credit"
            />
            <FormControlLabel
              value="credit"
              control={<Radio />}
              label="Credit sale"
            />
          </RadioGroup>
        </FormControl>
      </div>
      <div>
        <div className={classes.dashStyle} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              fontWeight: "700",
            }}
          >
            Sub Total
          </p>
          <p
            style={{
              fontWeight: "700",
            }}
          >
            {currencyFormatter(getSubTotal())}
          </p>
        </div>
        {billLineSettings.discount && (
          <div className="rightBottomContainer-discount">
            <p>Discount</p>
            <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
              <select
                style={{
                  width: "100px",
                }}
                onChange={(e) =>
                  dispatch({
                    type: "UPDATE_DISCOUNT_TYPE",
                    payload: e.target.value,
                  })
                }
                placeholder="Select"
                value={billingPayload.discountType}
              >
                <option value={""}>Type</option>
                <option value={"flat"}>Flat</option>
                <option value={"percentage"}>Percentage</option>
              </select>
              <TextField
                id="standard-basic"
                onChange={(e) => {
                  dispatch({
                    type: "UPDATE_DISCOUNT_VALUE",
                    payload: e.target.value,
                  });
                }}
                value={billingPayload.discount}
                name="billDiscount"
                variant="standard"
                style={{
                  height: 16,
                  width: 50,
                  marginTop: 1,
                  padding: 0,
                  textAlign: "left",
                }}
                inputProps={{
                  style: {
                    padding: 0,
                    fontSize: 13,
                    textAlign: "left",
                  },
                }}
              ></TextField>
            </div>
          </div>
        )}
        {Object.keys(billingPayload.loyalty).length > 0 && (
          <div className="rightBottomContainer-loyaltydiscount">
            <p>
              Loyalty Discount(Points){" "}
              <span
                style={{
                  color: "#5194C6",
                  fontSize: 16,
                  marginLeft: 20,
                  cursor: "pointer",
                }}
                onClick={handleLoyalityPoints}
              >
                <CloseOutlined />
              </span>
            </p>
            <p>{billingPayload.loyalty.minLoyaltyPointsReq} Points</p>
          </div>
        )}
        {Object.keys(billingPayload.coupon).length > 0 && (
          <div className="rightBottomContainer-coupondiscount">
            <p>
              Coupon Discount({billingPayload.coupon.promocode}){" "}
              <span
                style={{
                  color: "#5194C6",
                  fontSize: 16,
                  marginLeft: 20,
                  cursor: "pointer",
                }}
                onClick={handleCouponClick}
              >
                <CloseOutlined />
              </span>
            </p>
            <p>
              -
              {billingPayload.coupon.discountType === "flat"
                ? parseFloat(billingPayload.coupon.discountAmount).toFixed(2)
                : (
                    (billTotalAfterLoyalty *
                      parseFloat(billingPayload.coupon.discountAmount)) /
                    100
                  ).toFixed(2)}
            </p>
          </div>
        )}
        {billLineSettings.otherCharges &&
          billLineSettings.otherChargesField.map((data) => (
            <div className="rightBottomContainer-customcharge" key={data.id}>
              <p>{data.name.charAt(0).toUpperCase() + data.name.slice(1)}</p>
              <TextField
                type="number"
                placeholder={data.name}
                value={data.price}
                onChange={(event) =>
                  dispatch({
                    type: "UPDATE_OTHER_CHARGER",
                    payload: billLineSettings.otherChargesField.map(
                      (arrData) => {
                        if (arrData.id === data.id) {
                          if (event.target.value === "") {
                            return {
                              ...arrData,
                              price: "",
                            };
                          }
                          return {
                            ...arrData,
                            price: event.target.value,
                          };
                        } else {
                          return arrData;
                        }
                      }
                    ),
                  })
                }
                style={{
                  height: 16,
                  width: 50,
                  marginTop: 1,
                  padding: 0,
                  textAlign: "left",
                }}
                inputProps={{
                  style: {
                    padding: 0,
                    fontSize: 13,
                    textAlign: "left",
                  },
                }}
              ></TextField>
            </div>
          ))}
        <div className={classes.dashStyle} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span
            style={{
              fontSize: 24,
              fontWeight: "700",
              color: "#128C7E",
            }}
          >
            Total Amount
          </span>
          <span
            style={{
              fontSize: 24,
              fontWeight: "700",
              color: "#128C7E",
            }}
          >
            {currencyFormatter(getTotalAmount())}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 16,
            marginTop: 16,
          }}
        >
          <Button
            style={{
              width: "100%",
              color: "#EF4667",
              fontWeight: "700",
              background: "##FDE8EC",
            }}
            size="large"
            variant="outlined"
            onClick={handlePrintKot}
          >
            Print KOT
          </Button>
          <Button
            onClick={handleGenerateBill}
            style={{
              width: "100%",
              color: "#fff",
              fontWeight: "700",
              background: "#EF4667",
            }}
            size="large"
            variant="contained"
          >
            Generate Bill
          </Button>
        </div>
      </div>
      <Redeemmodal open={isRedeemModal} setOpen={setIsRedeemModal} />
      <ConfirmModal open={isConfirmModal} setOpen={setIsConfirmModal} />
      <AddItemModal open={addItemModal} setOpen={setAddItemModal} />
    </div>
  );
};

export default BillingPayDetails;
